import { render, staticRenderFns } from "./erased_block.vue?vue&type=template&id=42569ae2&"
import script from "./erased_block.vue?vue&type=script&lang=js&"
export * from "./erased_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "erased_block.vue"
export default component.exports